var r = {};
export {
  r as __exports
};
//# sourceMappingURL=react-is.production.min2.js.map
